import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { getEvents } from './gcal';
import { intToString } from './intToString'
import "./App.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const calendarID=window.calEnv.calendarID;
const max_bookings=window.calEnv.max_bookings;
const site_name=window.calEnv.site_name;
const max_guests=window.calEnv.max_guests;
const bookingDateFieldID=window.calEnv.bookingDateFieldID; // 'input_20_8' //jQuery('label:contains("Booking Date")').attr("for")
const site_nameFieldID=window.calEnv.site_nameFieldID; // 'input_20_17' //jQuery('label:contains("site_name")').attr("for") 
const calendarIDFieldID=window.calEnv.calendarIDFieldID; // 'input_20_18' //jQuery('label:contains("calendarID")').attr("for") 
const max_bookingsFieldID=window.calEnv.max_bookingsFieldID; // 'input_20_19' //jQuery('label:contains("max_bookings")').attr("for") 
const guestsFieldID=window.calEnv.guestsFieldID; // 'input_20_33' ///jQuery('label:contains("Day Guests")').attr("for") 

class App extends Component {
  
  constructor () {
    super()
    this.state = {
      events: []
      //site: []
    }
  }

  componentDidMount () {
    getEvents((events) => {
      this.setState({events})
    })
  }

  componentDidUpdate () {
    //console.log('updated')
    //var bookingDateFieldID = jQuery('label:contains("Booking Date")').attr("for")
    //var site_nameFieldID = jQuery('label:contains("site_name")').attr("for") 
    //var calendarIDFieldID = jQuery('label:contains("calendarID")').attr("for") 
    //var max_bookingsFieldID = jQuery('label:contains("max_bookings")').attr("for") 
    //var dayGuestsFieldID = jQuery('label:contains("Day Guests")').attr("for")  
    //var nightGuestsFieldID = jQuery('label:contains("Night Guests")').attr("for")  
    //// var bookingDateFieldID = 'input_20_8' //jQuery('label:contains("Booking Date")').attr("for")
    //// var site_nameFieldID = 'input_20_17' //jQuery('label:contains("site_name")').attr("for") 
    //// var calendarIDFieldID = 'input_20_18' //jQuery('label:contains("calendarID")').attr("for") 
    //// var max_bookingsFieldID = 'input_20_19' //jQuery('label:contains("max_bookings")').attr("for") 
    var dayGuestsHtml = '<option value="0" selected>Pick Date First</option>'
    var nightGuestsHtml = ''
    //// var guestsFieldID = 'input_20_33' ///jQuery('label:contains("Day Guests")').attr("for")  
    //var nightGuestsFieldID = //jQuery('label:contains("Night Guests")').attr("for")  
    
    document.getElementById(guestsFieldID).innerHTML = dayGuestsHtml + nightGuestsHtml 
      
    document.getElementById(bookingDateFieldID).value = 'Pick Date' // ALTER FORM ID  Need this to reset the date form field if a user clicks "back" after submission.
    document.getElementById(bookingDateFieldID).readOnly = true
    document.getElementById(site_nameFieldID).value = site_name
    document.getElementById(calendarIDFieldID).value = calendarID
    document.getElementById(max_bookingsFieldID).value = max_bookings

    
  }

eventStyleGetter (event, start, end, isSelected) {
    //console.log('Style Getterz ' + event.start)
    var backgroundColor = event.colour
    //console.log(event.colour)
    //console.log('isDevJs = ' + isDev)
    //BEN console.log('setting style')
    var style = {
        backgroundColor: backgroundColor, //,
        borderRadius: '1px',
        opacity: 1.0,
        color: 'black',
        border: '4px',
        display: 'block',
        height: '52px',
        fontSize: 'small'
    }
    return {
        style: style
    }
  }

  slotSelected (slot) {
    var d = new Date(slot.start)
    //console.log('SLOT date full '  + d.getUTCDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear())
  }

  eventSelected (event) {

    var d = new Date(event.start)
    //// var bookingDateFieldID = 'input_20_8'; //jQuery('label:contains("Booking Date")').attr("for")    
    //var guestsFieldID = 
    //// var guestsFieldID = 'input_20_33'; //jQuery('label:contains("Family Members")').attr("for")    


    // *** this leaves us open to not just a bad parseint, but someone fiddling with the html
    // *** to make a booking possible where none were available.
    // *** checking with the events json before accepting the booking will fix this. 
    if (event.title == 'Full') {
      var daySpacesFree = event.title
      var nightSpacesFree = event.title
    } else {
      var spacesFree = event.title.split(" ")
      var rawDaySpacesFree = spacesFree[0].split("·")
      var rawNiohtSpacesFree = spacesFree[1].split("·")  
      var daySpacesFree = rawDaySpacesFree[0] //should parseint here but we're pretty safe...
      var nightSpacesFree = rawNiohtSpacesFree[0] //should parseint here but we're pretty safe...
    }
    console.log('daySpacesFree = ' + daySpacesFree + ' nightSpacesFree = ' + nightSpacesFree )
    
    var bookingDateFieldVal = ''
    var guestsHtml = ''

    var dayNight = 'Day'
    var gueststr = ''
    if (isNaN(daySpacesFree)) {
      var daySpacesFree = 0
      bookingDateFieldVal = 'Full'
      guestsHtml = '<option value="0" selected="selected">Pick other date</option>'
    } else {
//      bookingDateFieldVal = d.getUTCDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear()   
// using getUTCDate throws off the booking calendar by one day prior to the 28th of the month, 
// when you're on the 2nd of the month. To be investigated.
    bookingDateFieldVal = d.getDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear()      
    var pluses = 'Plus'
      for (var options = 0; (options < daySpacesFree && options < (max_guests+1)); options++) {
        if (options == 0) {
          pluses = ''
        } else if (options == 1) {
          pluses = 'Plus'
          gueststr = 'Guest'
        } else {
          pluses = 'Plus'
          gueststr = 'Guests'
        }
        var isSelected = ''
        if (options == 0) {
          isSelected='selected'
        }
        guestsHtml = guestsHtml + '<option value="' + options + dayNight + '" ' + isSelected + '>' + pluses + ' ' + (intToString(options, true)) + ' ' + gueststr + ' ' + dayNight + '</option>'
        //console.log(guestsHtml)
      }
    }

    var dayNight = 'Night'
    var gueststr = ''
    if (isNaN(nightSpacesFree)) {
      var nightSpacesFree = 0
      bookingDateFieldVal = 'Full'
      guestsHtml = '<option value="0" selected="selected">Pick other date</option>'
    } else {
//      bookingDateFieldVal = d.getUTCDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear()   
// using getUTCDate throws off the booking calendar by one day prior to the 28th of the month, 
// when you're on the 2nd of the month. To be investigated.
    bookingDateFieldVal = d.getDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear()      
    var pluses = 'Plus'
      for (var options = 0; (options < nightSpacesFree && options < (max_guests+1)); options++) {
        if (options == 0) {
          pluses = ''
        } else if (options == 1) {
          pluses = 'Plus'
          gueststr = 'Guest'
        } else {
          pluses = 'Plus'
          gueststr = 'Guests'
        }
        var isSelected = ''
        if (options == 0 && dayNight == 'Day') {
          isSelected='selected'
        }
        guestsHtml = guestsHtml + '<option value="' + options + dayNight + '" ' + isSelected + '>' + pluses + ' ' + (intToString(options, true)) + ' ' + gueststr + ' ' + dayNight + '</option>'
        //console.log(guestsHtml)
      }
    }

    document.getElementById(guestsFieldID).innerHTML = guestsHtml    
    document.getElementById(bookingDateFieldID).value = bookingDateFieldVal
  }

  render() {
    return (
      <div className="App">
        <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="month"
          timeslots={12}
          style={{height: '420px'}}
          selectable={true}
          views={['month']}
          events={this.state.events}
          onSelectSlot={(this.slotSelected)}
          eventPropGetter={(this.eventStyleGetter)}
          onSelectEvent={(this.eventSelected)}
        />
      </div>
    );
  }
}

export default App;